(ns frontend.ui.page.lp-portal.report.pdf.view
  (:require
   [frontend.tenant-customizations :as tenant-customizations]
   [frontend.ui.component.lp-portal.content.pdf.view :refer [content]]
   [frontend.ui.component.lp-portal.report.esg.gresb :as esg-gresb]
   [frontend.ui.style.theme.core :as theme]
   [frontend.utils :as fu]))

(defn- resi-v2-footer
  [report-title reporting-period template-type page-index]
  (let [skip-page-index (if (or (= template-type :lp-report-template.capman/real-estate-fund-hotels-v2)
                                (= template-type :lp-report-template.capman/real-estate-fund-hotels-v3))
                          26
                          27)]
    (if (or (= page-index 1)
            (= page-index skip-page-index))
      (clj->js {})
      (clj->js
       {:columns
        [#_{:margin [0 0 0 6]
          :canvas [{:type  "rect"
                    :x     20
                    :y     -4
                    :w     555
                    :h     0.5
                    :color (theme/color [:pdf :border])}]} 

         {:absolutePosition {:x 20 :y 0}
          :text             (str "Page " page-index)
          :fontSize         9
          :color            "#767676"}

         {:absolutePosition {:x 190 :y 0}
          :text             (str report-title " - " reporting-period " Fund Report")
          :fontSize         9
          :color            "#767676"} 
         
         {:margin           [0 0 0 0]
          :absolutePosition {:x 515 :y -10}
          :svg              (theme/svg-logo)
          :alignment        :left
          :fit              [65 32.5]}]}))))

(defn- lifeline-footer
  [report-title reporting-period page-index]
  (if (= page-index 1)
    (clj->js {})
    (clj->js
     {:columns [{:absolutePosition {:x 16 :y 1}
                 :text             (str report-title
                                        " "
                                        reporting-period)
                 :fontSize         8
                 :color            (theme/color [:pdf :footer :text])}
                {:absolutePosition {:x 800 :y 0}
                 :text             (str "Page " (dec page-index))
                 :fontSize         8
                 :color            (theme/color [:pdf :footer :text])}]})))




(defn- footer
  [reference-date template-type page-index]
  (let [nest-logo? (or (= template-type :lp-report-template.capman/credit-fund)
                       (= template-type :lp-report-template.capman/credit-fund-v2))
        sparkmind-theme? (= (theme/get-theme) :theme.lp-portal/sparkmind)
        dasos-template? (or (= template-type :lp-report-template.capman/dasos-natural-capital)
                            (= template-type :lp-report-template.capman/dasos-natural-capital-FIN))]
    (if (= page-index 1)
      (clj->js {})
      (clj->js
       {:columns [(when-not (tenant-customizations/capman?)
                    {:canvas [{:type      "line"
                               :x1        0
                               :y1        -10
                               :x2        842
                               :y2        -10
                               :lineWidth 0.5
                               :color     (theme/color [:pdf :border])}]})
                  (when-not dasos-template?
                    {:absolutePosition {:x 16 :y 1}
                     :text             (str page-index
                                            "\t\t"
                                            (fu/format-epoch reference-date
                                                             "dd MMM yyyy"))
                     :fontSize         8
                     :color            (theme/color [:pdf :footer :text])})
                  {:margin           [0 0 13 0]
                   :absolutePosition {:x 0
                                      :y (cond
                                           nest-logo? 0
                                           sparkmind-theme? -2
                                           :else -4)}
                   :svg              (if nest-logo?
                                       theme/nest-capital-logo-black
                                       (theme/svg-logo))
                   :alignment        :right
                   :fit              (cond
                                       nest-logo?
                                       [120 60]
                                       sparkmind-theme?
                                       [84 40]
                                       :else
                                       [50 25])}]}))))

(def ^:private fonts
  {:Palatino   {:bold "https://static.zapflow.com/fonts/palatino-types/PalatinoLTPro-Bold.ttf"}
   :NewsGothic {:normal      "https://static.zapflow.com/fonts/ngo_____.ttf"
                :bold        "https://static.zapflow.com/fonts/ngob____.ttf"
                :italics     "https://static.zapflow.com/fonts/ngoi____.ttf"
                :bolditalics "https://static.zapflow.com/fonts/ngobi___.ttf"}
   :Roboto     {:normal      "https://static.zapflow.com/fonts/Roboto-Regular.ttf"
                :bold        "https://static.zapflow.com/fonts/Roboto-Medium.ttf"
                :italics     "https://static.zapflow.com/fonts/Roboto-Italic.ttf"
                :bolditalics "https://static.zapflow.com/fonts/Roboto-MediumItalic.ttf"}
   :Arial      {:normal      "https://static.zapflow.com/fonts/Arial.ttf"
                :bold        "https://static.zapflow.com/fonts/ArialBold.ttf"
                :italics     "https://static.zapflow.com/fonts/ArialItalic.ttf"
                :bolditalics "https://static.zapflow.com/fonts/ArialBoldItalic.ttf"}
   :Raleway    {:normal      "https://static.zapflow.com/fonts/Raleway-Regular.ttf"
                :bold        "https://static.zapflow.com/fonts/Raleway-Bold.ttf"
                :italics     "https://static.zapflow.com/fonts/Raleway-Italic.ttf"
                :bolditalics "https://static.zapflow.com/fonts/Raleway-BoldItalic.ttf"}
   :OpenSans   {:normal      "https://static.zapflow.com/fonts/OpenSans-Regular.ttf"
                :bold        "https://static.zapflow.com/fonts/OpenSans-Bold.ttf"
                :italics     "https://static.zapflow.com/fonts/OpenSans-Italic.ttf"
                :bolditalics "https://static.zapflow.com/fonts/OpenSans-BoldItalic.ttf"}
   :CircularStdBook   {:normal      "https://static.zapflow.com/fonts/CircularStdBook.ttf"
                       :bold        "https://static.zapflow.com/fonts/CircularStdBlack.ttf"
                       :italics     "https://static.zapflow.com/fonts/CircularStdBookItalic.ttf"
                       :bolditalics "https://static.zapflow.com/fonts/CircularStdBoldItalic.ttf"}
   :SuperiorTitleBlack {:normal     "https://static.zapflow.com/fonts/SuperiorTitleBlack.ttf"
                        :bold     "https://static.zapflow.com/fonts/SuperiorTitleBlack.ttf"
                        :italics     "https://static.zapflow.com/fonts/SuperiorTitleBlack.ttf"}
   :FontAwesome {:normal "https://static.zapflow.com/fontawesome/webfonts/fa-regular-400.ttf"
                 :bold "https://static.zapflow.com/fontawesome/webfonts/fa-solid-900.ttf"}
   :MarlideDisplay {:normal "https://static.zapflow.com/fonts/MarlideDisplay_Regular.ttf"}
   :NewsGothicStd {:normal "https://static.zapflow.com/fonts/news-gothic-std-regular.ttf"
                   :bold "https://static.zapflow.com/fonts/news-gothic-std-bold 2.ttf"
                   :italics "https://static.zapflow.com/fonts/news-gothic-std-oblique.ttf"
                   :bolditalics "https://static.zapflow.com/fonts/news-gothic-std-bold-oblique.ttf"}})

(defn- create-pdf
  [doc-definition]
  ;; FIXME for some readon js/pdfMake is NOT what we set it to in file vfs_fonts.js !
  ;; (println (keys (js->clj (.. js/pdfMake -vfs))))
  (.call (aget js/pdfMake "createPdf")
         js/pdfMake
         (clj->js doc-definition)
         nil                                                                                        ;; Layouts
         (clj->js fonts)))

(def lifeline-front-page-images
  {:lp-report-template.lifeline/fund
   "https://static.zapflow.com/app/img/lp_portal/lifeline/fund_iv_cover.png"
   :lp-report-template.lifeline/fund-v
   "https://static.zapflow.com/app/img/lp_portal/lifeline/fund_v_cover2.png"
   :lp-report-template.lifeline/fund-vi
   "https://static.zapflow.com/app/img/lp_portal/lifeline/fund_vi_cover2.png"})

(defn- lifeline-front-page-image
  [template-type]
  (get lifeline-front-page-images
       template-type
       "https://static.zapflow.com/app/img/lp_portal/lifeline/lifeline_pdf_cover.jpg"))

(defn report
  ([view-data page-defs report-title reporting-period reference-date]
   (report view-data page-defs report-title reporting-period reference-date ""))
  ([view-data page-defs report-title reporting-period reference-date template-type]
   (let [doc-content (->> page-defs
                          (remove nil?)
                          (map :content)
                          (content))
         dasos-template? (or (= template-type :lp-report-template.capman/dasos-natural-capital)
                             (= template-type :lp-report-template.capman/dasos-natural-capital-FIN))
         v2-template? (or (= template-type :lp-report-template.capman/real-estate-fund-resi-v2)
                          (= template-type :lp-report-template.capman/real-estate-fund-hotels-v2)
                          (= template-type :lp-report-template.capman/real-estate-fund-hotels-v3))
         lifeline-template? (or (= template-type :lp-report-template.lifeline/fund)
                                (= template-type :lp-report-template.lifeline/fund-v)
                                (= template-type :lp-report-template.lifeline/fund-vi))]
     (create-pdf
      {:pageOrientation (if v2-template? :portrait :landscape)
       :pageMargins     (cond
                          lifeline-template?
                          [20 24 20 24]
                          v2-template?
                          [20 24 20 24]
                          dasos-template?
                          [20 0 20 20]
                          (tenant-customizations/capman?)
                          [0 0 0 24]
                          :else
                          [20 0 20 24])
       :pageSize        {:width  595
                         :height 842}
       :content         doc-content
       :footer          (cond lifeline-template?
                              (partial lifeline-footer report-title reporting-period)
                              v2-template?
                              (partial resi-v2-footer report-title reporting-period template-type)
                              :else
                              (partial footer reference-date template-type))
       :images
       (merge
        (:pdf-images view-data)
        {:front-page-image
         (cond
           dasos-template?
           "https://static.zapflow.com/app/img/lp_portal/capman/Dasos_PDF_cover.jpg"
           (or (tenant-customizations/capman?) (= (theme/get-theme) :theme.lp-portal/capman))
           (or
            (:lp-report/pdf-front-page-image view-data)
            "https://static.zapflow.com/app/img/lp_portal/capman/Zapflow_Capman_PDF_bgr%201.jpg")
           (= (theme/get-theme) :theme.lp-portal/reindeer-partners)
           "https://static.zapflow.com/images/desktop/login-background-3-min.jpeg"
           (= (theme/get-theme) :theme.lp-portal/sparkmind)
           "https://static.zapflow.com/app/img/lp_portal/sparkmind/sparkmind-pdf-cover-2026-dim.jpg"
           (= (theme/get-theme) :theme.lp-portal/voima)
           "https://static.zapflow.com/app/img/lp_portal/voima/05_coastline.jpg"
           (= (theme/get-theme) :theme.lp-portal/innovestor)
           "https://static.zapflow.com/app/img/lp_portal/innovestor/Innovestor-pdf-cover.png"
           (= (theme/get-theme) :theme.lp-portal/sponsor-capital)
           "https://static.zapflow.com/app/img/lp_portal/reindeerpartners/header-mitateemme.jpg"
           lifeline-template?
           (lifeline-front-page-image template-type)
           :else
           "https://static.zapflow.com/images/desktop/login-background-3-min.jpeg")}
        (->> esg-gresb/gresb-configs
             (keep (fn [c]
                     (when-let [image (:image c)]
                       [(:key c) image])))
             (into {}))
        (->> esg-gresb/gresb-configs-2023
             (keep (fn [c]
                     (when-let [image (:image c)]
                       [(:key c) image])))
             (into {}))
        (->> esg-gresb/gresb-configs-2024
             (keep (fn [c]
                     (when-let [image (:image c)]
                       [(:key c) image])))
             (into {}))
        (->> esg-gresb/gresb-configs-2025
             (keep (fn [c]
                     (when-let [image (:image c)]
                       [(:key c) image])))
             (into {}))
        (->> esg-gresb/green-building-configs
             (keep (fn [c]
                     (when-let [image (:image c)]
                       [(:key c) image])))
             (into {}))
        (->> esg-gresb/EPC-configs
             (keep (fn [c]
                     (when-let [image (:image c)]
                       [(:key c) image])))
             (into {}))
        (->> esg-gresb/portfolio-snapshot-configs
             (keep (fn [c]
                     (when-let [image (:image c)]
                       [(:key c) image])))
             (into {}))
        (->> esg-gresb/hotels-portfolio-snapshot-configs
             (keep (fn [c]
                     (when-let [image (:image c)]
                       [(:key c) image])))
             (into {}))
        (->> esg-gresb/financial-snapshot-configs
             (keep (fn [c]
                     (when-let [image (:image c)]
                       [(:key c) image])))
             (into {}))
        (->> esg-gresb/esg-snapshot-configs
             (keep (fn [c]
                     (when-let [image (:image c)]
                       [(:key c) image])))
             (into {}))
        (->> esg-gresb/hotels-esg-snapshot-configs
             (keep (fn [c]
                     (when-let [image (:image c)]
                       [(:key c) image])))
             (into {})))

       :defaultStyle    {:font             (cond
                                             v2-template?
                                             "NewsGothicStd"
                                             (tenant-customizations/capman?)
                                             "NewsGothic"
                                             (= (theme/get-theme) :theme.lp-portal/sparkmind)
                                             "Raleway"
                                             (= (theme/get-theme) :theme.lp-portal/innovestor)
                                             "OpenSans"
                                             (= (theme/get-theme) :theme.lp-portal/lifeline)
                                             "CircularStdBook"
                                             :else
                                             "Arial")
                         :fontSize         7.5
                         :lineHeight       1.5
                         :margin           [10 5 10 0]
                         ;; TODO Watch-out: above 1.1, esg-page-3-pages starts to produce more pages
                         ;; than expected
                         :characterSpacing -0.2}

       :styles          {:main-header  {:fontSize 30
                                        :bold     true
                                        :margin   [10 10 10 10]}

                         :subheader    {:fontSize 15
                                        :margin   [10 10 10 10]
                                        :bold     true}

                         :table-header {:fontSize 20
                                        :margin   [10 10 10 10]
                                        :bold     true}}}))))

(defn generic-report
  [_view-data page-defs _report-title _reporting-period reference-date _image-url _font]
  (let [doc-content (->> page-defs
                         (remove nil?)
                         (map :content)
                         (content))]
    (create-pdf
     {:pageOrientation :landscape
      :pageMargins     [0 0 0 0]
      :pageSize        {:width  595
                        :height 842}
      :content         doc-content
      :footer          (partial footer reference-date)
      :images          {}

      :defaultStyle    {:font             "Arial"
                        :fontSize         7.5
                        :lineHeight       1.5
                        :margin           [10 5 10 0]
                        :characterSpacing -0.2}

      :styles          {:main-header  {:fontSize 5
                                       :bold     true
                                       :margin   [5 5 5 5]}

                        :subheader    {:fontSize 15
                                       :margin   [10 10 10 10]
                                       :bold     true}

                        :table-header {:fontSize 20
                                       :margin   [10 10 10 10]
                                       :bold     true}}})))
